import type { PublicSlotKey } from '@/apilib';
import type { WizardApi } from './wizardApi';

export const WizardApiKey: PublicSlotKey<WizardApi> = {
  name: 'WizardApi',
  public: true,
};
